import Users from "./components/Users/Users";

export default Users;
